import { render } from "./commercialNumberPool.vue?vue&type=template&id=b3ff37fe&scoped=true"
import script from "./commercialNumberPool.vue?vue&type=script&lang=js"
export * from "./commercialNumberPool.vue?vue&type=script&lang=js"

import "./commercialNumberPool.vue?vue&type=style&index=0&id=b3ff37fe&scoped=true&lang=css"
import "./commercialNumberPool.vue?vue&type=style&index=1&id=b3ff37fe&lang=css"
script.render = render
script.__scopeId = "data-v-b3ff37fe"

export default script